import { useContext } from "react";
import { BaseBenefitsColumns } from "@/components/BaseComponents/BaseBenefitsColumns";
import { BaseCompanyLogo } from "@/components/BaseComponents/BaseCompanyLogo";
import BaseCompanyName from "@/components/BaseComponents/BaseCompanyName";
import BaseLinkWrapper from "@/components/BaseComponents/BaseLinkWrapper";
import BaseProductDescription from "@/components/BaseComponents/BaseProductDescription";
import BaseServiceFlag from "@/components/BaseComponents/BaseServiceFlag";
import { BaseSoftwareRating } from "@/components/BaseComponents/BaseSoftwareRating";
import { BaseTrustpilotReview } from "@/components/BaseComponents/BaseTrustpilotReview";
import { BaseVisitLink } from "@/components/BaseComponents/BaseVisitLink";
import { CompanyContext } from "@/components/CompanyList/CompanyContext";
import { getAwardText } from "@/selectors";
import { useSelector } from "react-redux";

import { getStyles } from "./styles";
import {
	DEFAULT_LINK_TEXT,
	ThemeContext,
	TRUSTPILOT_REVIEW_WIDGET,
	WEB_REVIEW_WIDGET,
} from "./ThemeContext";

export const FavySoftwareLayout = () => {
	const { linkText = DEFAULT_LINK_TEXT, reviewWidget = null } =
		useContext(ThemeContext);

	const { company } = useContext(CompanyContext);
	const awardText = useSelector((state) => getAwardText(state, { company }));

	const styles = getStyles();

	return (
		<div className="tw:mb-5 tw:block tw:overflow-hidden tw:rounded-lg tw:bg-white tw:shadow-[0px_1px_2px_0px_rgba(88,102,126,0.12),0px_4px_24px_0px_rgba(88,102,126,0.06)]">
			<div className="tw:flex tw:min-h-[250px] tw:flex-col tw:items-center tw:justify-center tw:py-6 tw:lg:flex-row tw:lg:items-stretch tw:lg:justify-start">
				{/* Column 1 */}
				<div
					className={`tw:relative tw:flex tw:w-full tw:max-w-none tw:flex-col tw:justify-center tw:lg:w-[25%] ${awardText ? "tw:pt-6 tw:lg:pt-0" : ""}`}
				>
					<BaseLinkWrapper>
						<BaseServiceFlag classNames={styles.serviceFlag} />
						<div className="tw:flex tw:justify-evenly">
							<BaseCompanyLogo classNames={styles.companyLogo} />
							{reviewWidget && (
								<div className="tw:flex tw:items-center tw:justify-center tw:lg:hidden">
									{reviewWidget === TRUSTPILOT_REVIEW_WIDGET && (
										<BaseTrustpilotReview
											classNames={styles.trustpilotReview}
										/>
									)}
									{reviewWidget === WEB_REVIEW_WIDGET && (
										<BaseSoftwareRating classNames={styles.rating} />
									)}
								</div>
							)}
						</div>
					</BaseLinkWrapper>
				</div>
				{/* Column 2 */}
				<div className="tw:my-2 tw:flex tw:w-[90%] tw:max-w-none tw:flex-col tw:items-start tw:justify-center tw:px-0 tw:lg:my-0 tw:lg:w-[53%]">
					<BaseLinkWrapper>
						<div>
							<BaseCompanyName className="tw:mb-6 tw:text-2xl tw:leading-6 tw:font-bold tw:text-[#000a25]" />
							<BaseProductDescription className="tw:mb-6 tw:leading-6 tw:text-[#000a25]" />
						</div>
						<div>
							<BaseBenefitsColumns classNames={styles.benefitsList} />
						</div>
					</BaseLinkWrapper>
				</div>
				{/* Column 3 */}
				<BaseLinkWrapper className="tw:flex tw:w-full tw:max-w-none tw:flex-row tw:flex-wrap tw:items-center tw:justify-evenly tw:gap-4 tw:lg:flex-1 tw:lg:flex-col tw:lg:justify-center tw:lg:px-4">
					<BaseVisitLink {...styles.visitLink}>{linkText}</BaseVisitLink>
					<div className="tw:hidden tw:lg:block">
						{reviewWidget === TRUSTPILOT_REVIEW_WIDGET && (
							<BaseTrustpilotReview classNames={styles.trustpilotReview} />
						)}
						{reviewWidget === WEB_REVIEW_WIDGET && (
							<BaseSoftwareRating classNames={styles.rating} />
						)}
					</div>
				</BaseLinkWrapper>
			</div>
		</div>
	);
};
